import Dataprivacy from './Dataprivacy'

export default Dataprivacy
